<template>
  <div class="wrapper">
    <div v-if="ieBrowser" class="message_alert">
      <el-alert
        title="当前浏览器非推荐浏览器，建议使用谷歌浏览器或360极速版进行访问。"
        center
        type="error"
        @close="handleClose"
      ></el-alert>
    </div>
    <v-head></v-head>
    <div style="display: flex; height: calc(100% - 50px)">
      <v-sidebar @menuChange="menuChange"></v-sidebar>
      <v-side-right></v-side-right>
    </div>
    <!-- 
      left:
          menuIndex === '10136' || menuIndex === '350' || this.menuIndex === '540'
            ? '120px'
            : '270px',
     -->
    <div
      class="content-box"
      :class="{ 'content-collapse': collapse }"
      :style="{
        left: !isShowRightBar ? '120px' : '270px',
        top: ieBrowser ? '90px' : '50px',
      }"
    >
      <v-tags></v-tags>
      <div style="display: flex; height: 100%; z-index: -1">
        <div class="collapse-s" @click="slide">
          <div class="pointer"></div>
          <i
            style="transform: rotate(180deg); position: absolute; left: 8px; top: 40%"
            :class="collapse ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"
          ></i>
        </div>
        <div ref="content" class="content" style>
          <transition name="move" mode="out-in">
            <keep-alive
              :include="[
                'orderManage',
                'EnquiryManagePur',
                'HavePrice',
                'DirectedInquiry',
                'OpenInquiry',
                'DemandAudit',
                'ProcurementPlan',
                'allOrders',
                'EnquiryAudit',
                'invocieManage',
                'afterSaleManage',
                'GoodsMaintenance',
              ]"
            >
              <!-- <keep-alive
              :include="tagsList"
              :exclude="[
                'enterpriseInfoReviewDetails',
                'enterpriseInfoReviewReview',
                'esOrderDetails',
                'esReportReviewDetails',
                'agreementDetail',
                'maintenanceGoods',
                'assignRole',
                'orderDeliverDetail',
                'orderDetailOrConfirm',
                'invoiceDetail',
                'createApprove',
                'orderApprove',
                'eventRegistration',
                'activityNotification',
                'openingCollection',
                'sharedResourceAgreementManage',
                'sharedResourceAgreementDetail',
              ]"
            > -->
              <router-view></router-view>
            </keep-alive>
          </transition>
          <transition-group name="move" mode="out-in">
            <component
              :is="item.name"
              v-for="item in hasOpenComponentsArr"
              v-show="$route.path === item.path"
              :key="item.name"
            ></component>
          </transition-group>
          <el-backtop target=".content"></el-backtop>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapMutations } from 'vuex';
import vHead from './header.vue';
import vSidebar from './sider-bar.vue';
import vSideRight from './sider-right.vue';
import vTags from './tags.vue';
import bus from './bus';

export default {
  components: {
    vHead,
    vSidebar,
    vTags,
    vSideRight,
  },
  data() {
    return {
      // tagsList: [],
      collapse: false,
      menuList: [{}, {}],
      menuIndex: '10136',
      slideIndex: '',
      ieBrowser: false,
      componentsArr: [], // 含有iframe的页面
    };
  },
  computed: {
    // 实现懒加载，只渲染已经打开过（hasOpen:true）的iframe页
    hasOpenComponentsArr() {
      return this.componentsArr.filter((item) => item.hasOpen);
    },
    menuListData() {
      return this.$store.state.MENUINFO;
    },
    tagsList() {
      return this.$store.state.tagsList.map((item) => item.name);
    },
    isShowRightBar() {
      return this.$store.state.isShowRightBar;
    },
  },
  watch: {
    $route() {
      // 判断当前路由是否iframe页
      this.isOpenIframePage();
    },
    isShowRightBar(newVal) {
      this.collapse = newVal;
    },
  },
  mounted() {
    this.$refs.content.addEventListener('scroll', () => {
      bus.$emit('closeSelect');
    });
    // 判断是否是ie浏览器
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      if (!sessionStorage.getItem('ieBrowser')) {
        this.ieBrowser = true;
      }
    } else {
      this.ieBrowser = false;
    }
  },
  created() {
    this.collapse = this.isShowRightBar;
    // 设置iframe页的数组对象
    const componentsArr = this.getComponentsArr();
    componentsArr.forEach((item) => {
      Vue.component(item.name, item.component);
    });
    this.componentsArr = componentsArr;
    // 判断当前路由是否iframe页
    this.isOpenIframePage();

    /* bus.$on('collapse-content', msg => {
      this.collapse = msg;
    }); */

    // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
    bus.$on('tags', (msg) => {
      const arr = [];
      for (let i = 0, len = msg.length; i < len; i++) {
        msg[i].name && arr.push(msg[i].name);
      }
      // this.tagsList = arr
    });
  },
  methods: {
    ...mapMutations(['HADNDLE_COLLAPSE']),
    isOpenIframePage() {
      const target = this.componentsArr.find((item) => {
        return item.path === this.$route.path;
      });
      if (target && !target.hasOpen) {
        target.hasOpen = true;
      }
    },
    // 遍历路由的所有页面，把含有iframeComponent标识的收集起来
    getComponentsArr() {
      const router = this.$router;
      const routes = router.options.routes.filter((item) => item.name === 'home')[0].children;
      const iframeArr = routes.filter((item) => item.iframeComponent);
      // console.log(iframeArr)
      return iframeArr.map((item) => {
        const name = item.name || item.path.replace('/', '');
        return {
          name,
          path: item.path,
          hasOpen: false, // 是否打开过，默认false
          component: item.iframeComponent, // 组件文件的引用
        };
      });
    },
    menuChange(index) {
      this.slideIndex = index;
      this.menuIndex = index;
      if (this.menuIndex === '10136' || this.menuIndex === '350' || this.menuIndex === '540') {
        this.collapse = false;
      } else {
        this.collapse = true;
      }
      this.HADNDLE_COLLAPSE(this.collapse);
    },
    slide() {
      // if (this.$route.path === '/dashboard') return;
      this.collapse = !this.collapse;
      this.$store.commit('getRightBar', this.collapse);
      /* bus.$emit('collapse', this.collapse);
      this.collapse ? (this.menuIndex = this.slideIndex) : (this.menuIndex = '10136');
      if (this.menuIndex === '10136' || this.menuIndex === '350' || this.menuIndex === '540') {
        this.collapse = false;
      } else {
        this.collapse = true;
      }
      this.HADNDLE_COLLAPSE(this.collapse); */
    },
    // 关闭提示
    handleClose() {
      this.ieBrowser = false;
      sessionStorage.setItem('ieBrowser', 'ieBrowser');
    },
  },
};
</script>
<style lang="scss" scoped>
.message_alert {
  width: 100%;
}
::v-deep .el-alert {
  border-radius: 0;
  padding: 10px 16px;
  line-height: normal;
  display: flex;
  align-items: center;
}

::v-deep .el-alert__title {
  line-height: normal;
  font-size: 14px;
  display: flex;
}
::v-deep .el-backtop {
  bottom: 60px !important;
}
.content-box {
  position: absolute;
  right: 0;
  //   top: 50px;
  bottom: 0;
  padding-bottom: 30px;
  transition: left 0.3s ease-in-out;
  background: #f0f0f0;
  // box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  z-index: 30;
}
.content {
  width: 100%;
}
.collapse-s {
  width: 15px;
  // height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666666;
  background: #f8f8f8;
  position: relative;
  // z-index:30;
  .pointer {
    position: absolute;
    top: 40%;
  }
  .pointer:before {
    position: absolute;
    border-color: transparent transparent #f8f8f8;
    border-style: none solid solid;
    border-width: 0 15px 15px;
    content: '';
    display: block;
    height: '';
    left: -30px;
    top: 20%;
    width: 50px;
    transform: rotate(90deg);
  }
}
</style>
